<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">List Item</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.colPerView"
                  type="number"
                  label="Columns per view"
                  min="1"
                  max="8"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="4">
                <ColorPicker
                  :value="fields.colorBrand"
                  name="color-brand"
                  label="Color brand"
                  default-color="#005F2A"
                  @input="value => (fields.colorBrand = value)"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Items ({{ fields.items.length }})</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion class="mt-2">
            <v-expansion-panel v-for="(item, index) in fields.items" :key="`eskiin-hurrybox-item-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <div class="line-clamp-1" v-html="`${item.preText} ${item.price}`"></div>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="item.preText" label="Pre text" hide-details />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="item.price" label="Price" hide-details />
                  </v-col>
                </v-row>
                <label class="mt-4 mb-2 d-block">Image</label>
                <UploadImage
                  @callback="obj => handleUploadItemImage(obj, index)"
                  :image="{ imageSrc: item.image || '' }"
                  :height="`150`"
                  :typeUpload="'image'"
                  @callbackDelete="() => handleRemoveItemImage(index)"
                />
                <label class="mt-4 mb-2 d-block">Title</label>
                <ckeditor :editor="editor" v-model="item.title" :config="editorConfig" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import ColorPicker from './common/color-picker.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'eskiin-hurrybox-section-editor',
  components: {
    UploadImage,
    ColorPicker,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Eskiin hurrybox',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        colPerView: 4,
        colorBrand: '#005F2A',
        items: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        items: Array.isArray(extract.items) ? extract.items : this.fields.items,
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionEskiinHurrybox(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.items.push({
        preText: 'FREE',
        price: '$16',
        image: '',
        title: '<p>Title</p>',
      });
    },
    handleRemoveItem(index) {
      this.fields.items.splice(index, 1);
    },
    handleUploadItemImage(obj, index) {
      if (!this.fields.items[index]) return;
      this.$set(this.fields.items[index], 'image', obj.imageSrc || '');
    },
    handleRemoveItemImage(index) {
      if (!this.fields.items[index]) return;
      this.$set(this.fields.items[index], 'image', '');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
